// import React from 'react'

// const Loader = () => {
//     return (
//         <div className="flex justify-center flex-col items-center h-40 gap-6">
//             <div className="relative">
//                 {/* Outer ring */}
//                 <div className="w-16 h-16 border-4 border-gray-200 rounded-full"></div>

//                 {/* Animated ring */}
//                 <div className="w-16 h-16 border-4 border-blue-500 rounded-full border-t-transparent animate-spin absolute top-0 left-0"></div>

//                 {/* Inner dot */}
//                 <div className="w-3 h-3 bg-blue-500 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
//             </div>

//             <div className="text-center space-y-2">
//                 <p className="text-xl font-semibold text-gray-800">Loading Data</p>
//                 <p className="text-sm text-gray-500">Please wait a moment...</p>
//             </div>
//         </div>
//     )
// }

// export default Loader



import React from "react";

const Loader = () => {
  return (
    <div className="flex justify-center flex-col items-center h-40 gap-6">
      <div className="relative">
        {/* Outer rotating ring with gradient */}
        <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#FDC700] to-yellow-500 animate-spin">
          <div className="w-full h-full rounded-full bg-white p-1">
            <div className="w-full h-full rounded-full bg-white"></div>
          </div>
        </div>

        {/* Inner solid circle (static) */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-gradient-to-br from-[#FDC700] to-yellow-600 shadow-lg shadow-yellow-200"></div>

        {/* Pulsing dot at center */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white rounded-full animate-pulse"></div>
      </div>

      <div className="text-center space-y-2">
        <p className="text-xl font-bold text-gray-800 tracking-wide">
          Loading<span className="animate-pulse">...</span>
        </p>
        <p className="text-sm text-gray-500 font-medium">
          Please wait while we fetch your data
        </p>
      </div>
    </div>
  );
};

export default Loader;